import { Row, Col } from 'antd';
import QRScanner from 'components/QRScanner';
import React, { FC } from 'react';
import * as texts from '../../assets/texts/scanCheck';

const ScanCheck: FC = () => (
  <Row style={{ width: '90%', margin: 'auto' }}>
    <Col span={24} md={12}>
      <h1>{texts.title}</h1>
      <h3>{texts.subTitle}</h3>
      <h4>{texts.body}</h4>
      <QRScanner header={null} />
    </Col>
  </Row>
);
export default ScanCheck;
